import PropTypes from "prop-types";
import { cn } from "@/lib/utils";

/**
 * FolderIcon - Folder outline icon
 */
export const FolderIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  strokeWidth = 1.5,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width={size}
    height={size}
    className={cn("icon", className)}
    {...props}
  >
    <g>
      <g transform="translate(2.75,3.5)">
        <path
          strokeLinecap="round"
          strokeLinejoin="miter"
          fill="none"
          strokeMiterlimit={4}
          stroke={color}
          strokeWidth={strokeWidth}
          d="M14.5,6 C14.5,5.808333396911621 14.5,5.616666793823242 14.5,5.425000190734863 C14.5,4.094880104064941 14.5,3.429810047149658 14.241100311279297,2.9217700958251953 C14.013400077819824,2.4748899936676025 13.650099754333496,2.111560106277466 13.203200340270996,1.8838599920272827 C12.695199966430664,1.625 12.030099868774414,1.625 10.699999809265137,1.625 C9.931366920471191,1.625 9.16273307800293,1.625 8.394100189208984,1.625 C8.242400169372559,1.625 8.166600227355957,1.625 8.093500137329102,1.6204999685287476 C7.561999797821045,1.5877100229263306 7.056839942932129,1.377210021018982 6.6593098640441895,1.0228099822998047 C6.604680061340332,0.974120020866394 6.551270008087158,0.9202499985694885 6.444439888000488,0.8125 C6.444439888000488,0.8125 6.444439888000488,0.8125 6.444439888000488,0.8125 C6.337619781494141,0.7047500014305115 6.284210205078125,0.650879979133606 6.229579925537109,0.6021900177001953 C5.83204984664917,0.24778999388217926 5.326930046081543,0.037289999425411224 4.795370101928711,0.0044999998062849045 C4.722330093383789,0 4.646470069885254,0 4.494740009307861,0 C4.263160228729248,0 4.031579971313477,0 3.799999952316284,0 C2.4698801040649414,0 1.8048100471496582,0 1.2967699766159058,0.2588599920272827 C0.8498899936676025,0.48655998706817627 0.48655998706817627,0.8498899936676025 0.2588599920272827,1.2967699766159058 C0,1.8048100471496582 0,2.469870090484619 0,3.799999952316284 C0,5.599999904632568 0,7.400000095367432 0,9.199999809265137 C0,10.530099868774414 0,11.195199966430664 0.2588599920272827,11.703200340270996 C0.48655998706817627,12.150099754333496 0.8498899936676025,12.513400077819824 1.2967699766159058,12.741100311279297 C1.8048100471496582,13 2.4698801040649414,13 3.799999952316284,13 C4.616666793823242,13 5.433333396911621,13 6.25,13"
        />
      </g>
      <g transform="translate(2.75,8.913877487182617)">
        <path
          strokeLinecap="round"
          strokeLinejoin="miter"
          fill="none"
          strokeMiterlimit={4}
          stroke={color}
          strokeWidth={strokeWidth}
          d="M0.5920000076293945,0 C0.38477998971939087,0 0.2811700105667114,0 0.20202000439167023,0.03922419250011444 C0.1324000060558319,0.07372163981199265 0.07580000162124634,0.12877944111824036 0.04033000022172928,0.19649054110050201 C0,0.27346059679985046 0,0.37422969937324524 0,0.5757679343223572 C0,1.6806167364120483 0,2.7854654788970947 0,3.8903141021728516 C0,5.183944225311279 0,5.830807685852051 0.2588599920272827,6.324878692626953 C0.48655998706817627,6.759525299072266 0.8498899936676025,7.112961292266846 1.2967699766159058,7.334417819976807 C1.8048100471496582,7.586122035980225 2.4698801040649414,7.586122035980225 3.799999952316284,7.586122035980225 C6.099999904632568,7.586122035980225 8.399999618530273,7.586122035980225 10.699999809265137,7.586122035980225 C12.030099868774414,7.586122035980225 12.695199966430664,7.586122035980225 13.203200340270996,7.334417819976807 C13.650099754333496,7.112961292266846 14.013400077819824,6.759525299072266 14.241100311279297,6.324878692626953 C14.5,5.830807685852051 14.5,5.183944225311279 14.5,3.8903141021728516 C14.5,2.7854654788970947 14.5,1.6806167364120483 14.5,0.5757679343223572 C14.5,0.37422969937324524 14.5,0.27346059679985046 14.459699630737305,0.19649054110050201 C14.424200057983398,0.12877944111824036 14.367600440979004,0.07372163981199265 14.29800033569336,0.03922419250011444 C14.218799591064453,0 14.11520004272461,0 13.907999992370605,0 C9.46933364868164,0 5.030666828155518,0 0.5920000076293945,0 C0.5920000076293945,0 0.5920000076293945,0 0.5920000076293945,0 C0.5920000076293945,0 0.5920000076293945,0 0.5920000076293945,0z"
        />
      </g>
    </g>
  </svg>
);

FolderIcon.displayName = "FolderIcon";
FolderIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  strokeWidth: PropTypes.number,
};

/**
 * MoneyIcon - Dollar currency icon
 */
export const MoneyIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn("icon", className)}
    {...props}
  >
    <path
      d="M12 7.75V6.75"
      stroke={color}
      strokeWidth={1.596}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 16.25V17.25"
      stroke={color}
      strokeWidth={1.596}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 15.0807C12 16.8044 14.5 15.8538 14.5 14.2826C14.5 11.5756 9.5 12.5263 9.5 9.81992C9.5 8.24806 12 7.29717 14 8.64047"
      stroke={color}
      strokeWidth={1.596}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9998 20.7001C16.8047 20.7001 20.6998 16.8049 20.6998 12C20.6998 7.19517 16.8047 3.30005 11.9998 3.30005C7.19493 3.30005 3.2998 7.19517 3.2998 12C3.2998 16.8049 7.19493 20.7001 11.9998 20.7001Z"
      stroke={color}
      strokeWidth={1.596}
    />
  </svg>
);

MoneyIcon.displayName = "MoneyIcon";
MoneyIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * BookIcon - Book outline icon
 */
export const BookIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    data-rtl-flip=""
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.9678 1.84863C16.2706 1.9108 16.499 2.17878 16.499 2.5V14.167C16.499 14.255 16.4812 14.3427 16.4473 14.4238C16.0328 15.4146 16.0327 16.2523 16.4473 17.2432C16.533 17.4482 16.5106 17.683 16.3877 17.8682C16.2645 18.0532 16.0563 18.1648 15.834 18.165H5.83398C4.54624 18.165 3.50195 17.1208 3.50195 15.833V4.16699C3.50195 2.87925 4.54624 1.83496 5.83398 1.83496H15.834L15.9678 1.84863ZM5.83398 14.832C5.31551 14.832 4.88842 15.2256 4.83691 15.7305L4.83203 15.833L4.83691 15.9355C4.88812 16.4407 5.31529 16.835 5.83398 16.835H14.9219C14.7689 16.1618 14.768 15.5052 14.9209 14.832H5.83398ZM5.83398 3.16504C5.28078 3.16504 4.83203 3.61379 4.83203 4.16699V13.7295C5.13566 13.5847 5.47519 13.502 5.83398 13.502H15.1689V3.16504H5.83398Z"
    />
  </svg>
);

BookIcon.displayName = "BookIcon";
BookIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * GraduationCapIcon - Graduation cap icon
 */
export const GraduationCapIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path d="M14.7514 10.9604L11.0072 12.7543C10.4499 13.0214 9.813 13.0552 9.23575 12.8549L8.99259 12.7543L5.24845 10.9604V13.2407C5.24846 13.861 5.56181 14.4391 6.08145 14.7778L6.72403 15.1967L6.91153 15.3139C8.87484 16.4927 11.3473 16.4539 13.2768 15.1967L13.9184 14.7778L14.1039 14.6401C14.5119 14.294 14.7514 13.7833 14.7514 13.2407V10.9604ZM17.6684 12.5004V9.56294L16.0815 10.3227V13.2407C16.0814 14.2438 15.6061 15.183 14.808 15.7778L14.6449 15.892L14.0024 16.311C11.6456 17.8465 8.62613 17.8941 6.22794 16.4545L5.99747 16.311L5.35587 15.892C4.45937 15.3079 3.91838 14.3107 3.91837 13.2407V10.3227L1.28067 9.06001C0.146312 8.51639 0.146391 6.90058 1.28067 6.35689L8.99259 2.66158L9.23575 2.56197C9.81293 2.36168 10.4499 2.39467 11.0072 2.66158L18.7191 6.35689L18.8217 6.41158C19.756 6.94606 19.8149 8.25491 18.9984 8.88716V12.5004C18.9982 12.8675 18.7005 13.1645 18.3334 13.1645C17.9663 13.1645 17.6686 12.8675 17.6684 12.5004ZM10.433 3.86177C10.1934 3.74696 9.91943 3.73257 9.6713 3.8188L9.56681 3.86177L1.85587 7.55611C1.72841 7.61718 1.72841 7.79875 1.85587 7.85982L9.56681 11.5551L9.6713 11.5981C9.91941 11.6843 10.1934 11.6699 10.433 11.5551L18.144 7.85982L18.1859 7.83247C18.258 7.76692 18.2579 7.65004 18.1859 7.58443L18.144 7.55611L10.433 3.86177Z" />
  </svg>
);

GraduationCapIcon.displayName = "GraduationCapIcon";
GraduationCapIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * PenIcon - Pen/writing icon
 */
export const PenIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  strokeWidth = 1.33,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path
      d="M3.33325 16.6663L13.5466 15.1342C14.0857 15.0534 14.5512 14.714 14.793 14.2255L17.3859 8.98829C17.7031 8.34755 17.5763 7.57586 17.0708 7.0703L12.9269 2.92643C12.4225 2.42201 11.653 2.29454 11.0128 2.60938L5.7636 5.19115C5.27224 5.43282 4.93094 5.90042 4.85056 6.44206L3.33325 16.6663ZM3.33325 16.6663L10.4165 9.58286"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4199 9.58008C11.4199 10.1324 10.9722 10.5801 10.4199 10.5801C9.86764 10.5801 9.41992 10.1324 9.41992 9.58008C9.41992 9.02779 9.86764 8.58008 10.4199 8.58008C10.9722 8.58008 11.4199 9.02779 11.4199 9.58008Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

PenIcon.displayName = "PenIcon";
PenIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  strokeWidth: PropTypes.number,
};

/**
 * BrushPenIcon - Brush pen/drawing icon
 */
export const BrushPenIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path
      d="M14.0405 2.8623C14.9501 2.35628 16.0341 2.59224 16.7212 3.2793C17.408 3.96644 17.6433 5.05051 17.1372 5.95996C15.2815 9.29433 11.9865 12.1904 8.99658 14.1133C8.99683 14.1294 8.99853 14.1459 8.99854 14.1621C8.99847 14.9892 8.76882 15.6599 8.32764 16.168C7.89536 16.6656 7.31621 16.9427 6.73682 17.1006C5.6188 17.4051 4.23644 17.3223 3.34326 17.3223C2.9762 17.3222 2.67841 17.0243 2.67822 16.6572C2.6782 15.7641 2.59544 14.3817 2.8999 13.2637C3.05781 12.6843 3.33492 12.1051 3.83252 11.6729C4.34065 11.2316 5.01124 11.002 5.83838 11.002C5.85397 11.002 5.86972 11.0027 5.88525 11.0029C7.80824 8.0127 10.7057 4.71816 14.0405 2.8623ZM14.5269 12.0293C14.754 11.8022 15.1047 11.7732 15.3628 11.9434L15.4673 12.0293L16.3237 12.8857C16.6804 13.2424 16.9125 13.7058 16.9839 14.2051L17.3218 16.5723C17.3512 16.7793 17.2812 16.9878 17.1333 17.1357C16.9854 17.2836 16.7769 17.3537 16.5698 17.3242L14.2026 16.9863C13.7033 16.9149 13.24 16.6828 12.8833 16.3262L12.0269 15.4697L11.9409 15.3652C11.7708 15.1072 11.7997 14.7564 12.0269 14.5293C12.254 14.3022 12.6047 14.2732 12.8628 14.4434L12.9673 14.5293L13.8237 15.3857C13.9769 15.5389 14.1767 15.6392 14.3911 15.6699L15.8794 15.8818L15.6675 14.3936C15.6368 14.1791 15.5365 13.9793 15.3833 13.8262L14.5269 12.9697L14.4409 12.8652C14.2708 12.6072 14.2997 12.2564 14.5269 12.0293ZM5.83838 12.332C5.26751 12.3321 4.92642 12.4851 4.70459 12.6777C4.47257 12.8795 4.29933 13.1868 4.18311 13.6133C3.99073 14.3197 3.99305 15.1628 4.00244 15.9971C4.83704 16.0065 5.68046 16.0099 6.38721 15.8174C6.81366 15.7012 7.12104 15.5279 7.32275 15.2959C7.51539 15.0741 7.66839 14.7329 7.66846 14.1621C7.66838 13.1514 6.84909 12.3321 5.83838 12.332ZM15.7798 4.21973C15.4628 3.90292 15.0181 3.84022 14.687 4.02441C11.7464 5.66087 9.10057 8.56744 7.25342 11.3389C7.86056 11.6438 8.35414 12.1374 8.65967 12.7441C11.431 10.897 14.3387 8.25296 15.9751 5.3125C16.1593 4.98139 16.0966 4.53666 15.7798 4.21973ZM5.46729 7.0293C5.72668 7.28902 5.72688 7.71013 5.46729 7.96973C5.20769 8.22933 4.78658 8.22913 4.52686 7.96973L5.46729 7.0293ZM3.27686 3.2793C4.22682 2.32933 5.76721 2.32952 6.71729 3.2793L7.96729 4.5293L7.49658 4.99902L7.02686 5.46973L5.77686 4.21973C5.34618 3.78935 4.64785 3.78916 4.21729 4.21973C3.78672 4.65029 3.78691 5.34862 4.21729 5.7793L5.46729 7.0293L4.99658 7.49902L4.52686 7.96973L3.27686 6.71973C2.32708 5.76965 2.32689 4.22926 3.27686 3.2793ZM7.96729 4.5293C8.22668 4.78902 8.22688 5.21013 7.96729 5.46973C7.70769 5.72933 7.28658 5.72913 7.02686 5.46973L7.96729 4.5293Z"
      fill={color}
    />
  </svg>
);

BrushPenIcon.displayName = "BrushPenIcon";
BrushPenIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * BracesIcon - Code braces icon
 */
export const BracesIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path d="M5.08496 15.0003V12.5003C5.08496 12.1781 4.91677 11.8776 4.63672 11.6898L4.50977 11.6155C4.0393 11.3828 3.33513 10.8582 3.33496 10.0003C3.33496 9.14215 4.03924 8.61683 4.50977 8.38409L4.63672 8.31085C4.91685 8.12306 5.08485 7.82254 5.08496 7.50031V5.00031C5.08496 3.68283 6.19768 2.66827 7.5 2.66827C7.86727 2.66827 8.16503 2.96605 8.16504 3.33331C8.16504 3.70058 7.86727 3.99835 7.5 3.99835C6.87032 3.99835 6.41504 4.47778 6.41504 5.00031V7.50031C6.41492 8.36161 5.93339 9.09884 5.24121 9.50031L5.09961 9.57648C4.94956 9.65069 4.82638 9.7415 4.74902 9.83038C4.67487 9.9156 4.66504 9.97101 4.66504 10.0003C4.66511 10.0297 4.6753 10.0845 4.74902 10.1693C4.82639 10.2581 4.94952 10.3499 5.09961 10.4241L5.24121 10.4993C5.93356 10.9008 6.41504 11.6388 6.41504 12.5003V15.0003C6.41521 15.49 6.81517 15.9418 7.38379 15.9964L7.5 16.0013L7.63379 16.015C7.93684 16.0768 8.16488 16.345 8.16504 16.6663C8.16504 16.9877 7.93688 17.2557 7.63379 17.3177L7.5 17.3314L7.25781 17.3196C6.06281 17.2032 5.08513 16.2351 5.08496 15.0003ZM13.585 15.0003V12.5003C13.585 11.5813 14.1332 10.8036 14.9004 10.4241L15.0078 10.3655C15.1093 10.3044 15.193 10.2359 15.251 10.1693C15.3247 10.0845 15.3349 10.0297 15.335 10.0003C15.335 9.97101 15.3251 9.9156 15.251 9.83038C15.193 9.76378 15.1092 9.69615 15.0078 9.63507L14.9004 9.57648C14.1332 9.19707 13.5851 8.4192 13.585 7.50031V5.00031C13.585 4.51052 13.1849 4.05889 12.6162 4.00421L12.5 3.99835L12.3662 3.98468C12.0631 3.92275 11.835 3.65474 11.835 3.33331C11.835 2.96604 12.1327 2.66827 12.5 2.66827L12.7422 2.67999C13.9373 2.79644 14.915 3.76533 14.915 5.00031V7.50031C14.9152 7.86853 15.1349 8.20836 15.4902 8.38409L15.6758 8.48468C16.1258 8.75277 16.665 9.24929 16.665 10.0003C16.6649 10.7511 16.1257 11.2469 15.6758 11.515L15.4902 11.6155C15.1348 11.7913 14.915 12.132 14.915 12.5003V15.0003C14.9149 16.3176 13.8022 17.3314 12.5 17.3314C12.1327 17.3314 11.835 17.0336 11.835 16.6663C11.8351 16.2992 12.1328 16.0013 12.5 16.0013C13.1295 16.0013 13.5848 15.5227 13.585 15.0003Z" />
  </svg>
);

BracesIcon.displayName = "BracesIcon";
BracesIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * TerminalIcon - Terminal/command icon
 */
export const TerminalIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path d="M6.19629 7.86231C6.42357 7.63534 6.7752 7.60692 7.0332 7.77734L7.1377 7.86231L8.80371 9.5293C9.06329 9.78889 9.06307 10.21 8.80371 10.4697L7.1377 12.1367C6.878 12.3964 6.45599 12.3964 6.19629 12.1367C5.93686 11.8771 5.93697 11.456 6.19629 11.1963L7.39258 9.99902L6.19629 8.80371L6.11133 8.69922C5.94087 8.4411 5.96904 8.08955 6.19629 7.86231Z" />
    <path d="M13.4668 11.0156C13.7699 11.0776 13.998 11.3456 13.998 11.667C13.9979 11.9883 13.7698 12.2564 13.4668 12.3184L13.333 12.332H10.833C10.466 12.3319 10.1682 12.034 10.168 11.667C10.168 11.2998 10.4659 11.0021 10.833 11.002H13.333L13.4668 11.0156Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6602 2.66504C13.3492 2.66504 13.9062 2.66439 14.3564 2.70117C14.8142 2.73859 15.2201 2.81796 15.5967 3.00977C16.1922 3.31321 16.677 3.79805 16.9805 4.39356C17.1722 4.77014 17.2517 5.17604 17.2891 5.63379C17.3258 6.08402 17.3252 6.64102 17.3252 7.33008V12.6602C17.3252 13.3492 17.3258 13.9062 17.2891 14.3564C17.2516 14.8142 17.1723 15.2201 16.9805 15.5967C16.677 16.1922 16.1922 16.677 15.5967 16.9805C15.2201 17.1723 14.8142 17.2516 14.3564 17.2891C13.9062 17.3258 13.3492 17.3252 12.6602 17.3252H7.33008C6.64102 17.3252 6.08402 17.3258 5.63379 17.2891C5.17604 17.2517 4.77014 17.1722 4.39356 16.9805C3.79805 16.677 3.31321 16.1922 3.00977 15.5967C2.81796 15.2201 2.73859 14.8142 2.70117 14.3564C2.66439 13.9062 2.66504 13.3492 2.66504 12.6602V7.33008C2.66504 6.64101 2.66439 6.08402 2.70117 5.63379C2.73858 5.17601 2.81797 4.77016 3.00977 4.39356C3.31321 3.79802 3.79802 3.31321 4.39356 3.00977C4.77016 2.81797 5.17601 2.73858 5.63379 2.70117C6.08402 2.66439 6.64101 2.66504 7.33008 2.66504H12.6602ZM7.33008 3.99512C6.61907 3.99512 6.1257 3.99601 5.74219 4.02734C5.3665 4.05804 5.15508 4.11481 4.99707 4.19531C4.65183 4.37124 4.37124 4.65183 4.19531 4.99707C4.11481 5.15508 4.05805 5.3665 4.02734 5.74219C3.99601 6.1257 3.99512 6.61908 3.99512 7.33008V12.6602C3.99512 13.3711 3.99601 13.8646 4.02734 14.248C4.05805 14.6237 4.11481 14.8352 4.19531 14.9932C4.37124 15.3384 4.65186 15.619 4.99707 15.7949C5.15507 15.8754 5.36654 15.9322 5.74219 15.9629C6.1257 15.9942 6.61908 15.9951 7.33008 15.9951H12.6602C13.3711 15.9951 13.8646 15.9942 14.248 15.9629C14.6237 15.9322 14.8352 15.8754 14.9932 15.7949C15.3384 15.619 15.619 15.3384 15.7949 14.9932C15.8754 14.8352 15.9322 14.6237 15.9629 14.248C15.9942 13.8646 15.9951 13.3711 15.9951 12.6602V7.33008C15.9951 6.61908 15.9942 6.1257 15.9629 5.74219C15.9322 5.36654 15.8754 5.15507 15.7949 4.99707C15.619 4.65186 15.3384 4.37124 14.9932 4.19531C14.8352 4.11481 14.6237 4.05805 14.248 4.02734C13.8646 3.99601 13.3711 3.99512 12.6602 3.99512H7.33008Z"
    />
  </svg>
);

TerminalIcon.displayName = "TerminalIcon";
TerminalIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * WrenchIcon - Tools/wrench icon
 */
export const WrenchIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path d="M16.8347 7.91699C16.8347 7.76279 16.8266 7.61021 16.8123 7.45996L15.4705 8.80371C14.2903 9.98388 12.3762 9.98388 11.1961 8.80371C10.016 7.62352 10.0159 5.70942 11.1961 4.5293L12.5378 3.18652C12.3885 3.17238 12.237 3.16505 12.0837 3.16504C9.45947 3.16504 7.33179 5.29272 7.33179 7.91699C7.33184 8.56608 7.46162 9.18329 7.69605 9.74512C7.79981 9.9939 7.74311 10.2811 7.5525 10.4717L3.59547 14.4287C3.0498 14.9744 3.04991 15.8586 3.59547 16.4043L3.70191 16.501C4.25076 16.9483 5.05957 16.9158 5.57105 16.4043L9.52906 12.4473L9.60426 12.3828C9.79018 12.2455 10.0369 12.2131 10.2546 12.3037C10.8166 12.5382 11.4345 12.668 12.0837 12.668C14.7078 12.6678 16.8345 10.541 16.8347 7.91699ZM18.1648 7.91699C18.1646 11.2755 15.4423 13.9979 12.0837 13.998C11.4151 13.998 10.7708 13.8886 10.1677 13.6885L6.51246 17.3457C5.51389 18.3443 3.93332 18.406 2.86207 17.5322L2.65504 17.3457C1.58992 16.2806 1.58992 14.5534 2.65504 13.4883L6.31031 9.83203C6.1104 9.22921 6.00175 8.58526 6.00172 7.91699C6.00172 4.55818 8.72494 1.83496 12.0837 1.83496C12.7838 1.835 13.458 1.95316 14.0857 2.17188L14.1638 2.20508C14.3404 2.29325 14.4697 2.45713 14.5144 2.65234C14.5653 2.87533 14.4984 3.10876 14.3367 3.27051L12.1375 5.4707C11.4767 6.13148 11.4767 7.20251 12.1375 7.86328C12.7983 8.52373 13.8694 8.52395 14.53 7.86328L16.7293 5.66309L16.7937 5.60742C16.9499 5.48687 17.1532 5.44067 17.3484 5.48535C17.5714 5.53648 17.7526 5.69898 17.8279 5.91504C18.0466 6.54272 18.1648 7.21689 18.1648 7.91699Z" />
  </svg>
);

WrenchIcon.displayName = "WrenchIcon";
WrenchIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * BeakerIcon - Flask/science icon
 */
export const BeakerIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path d="M16.0012 14.4404C16.0011 13.9504 15.8513 13.4739 15.5735 13.0742L15.4465 12.9082L15.012 12.3877C13.8614 12.8911 12.9152 13.1121 12.0618 13.1562C11.1474 13.2035 10.3804 13.0475 9.66528 12.8857C8.94197 12.7221 8.2815 12.5562 7.4729 12.5146C6.70029 12.475 5.77576 12.5504 4.5686 12.8887L4.55298 12.9082C4.19457 13.3383 3.9984 13.8806 3.99829 14.4404C3.99829 15.7627 5.07059 16.835 6.39282 16.835H13.6077C14.9298 16.8349 16.0012 15.7626 16.0012 14.4404ZM11.8352 3.16504H8.16528V7.72949C8.16528 8.20671 8.01876 8.6713 7.74829 9.06055L7.62427 9.22266L5.93384 11.25C6.52115 11.1756 7.05045 11.1614 7.54028 11.1865C8.48665 11.2351 9.26917 11.432 9.95825 11.5879C10.6556 11.7456 11.2718 11.8653 11.9924 11.8281C12.5791 11.7978 13.2616 11.6591 14.1213 11.3184L12.3752 9.22266C12.0261 8.80363 11.8352 8.27494 11.8352 7.72949V3.16504ZM13.1653 7.72949C13.1653 7.96372 13.2468 8.19111 13.3967 8.37109L16.468 12.0566L16.6653 12.3154C17.0974 12.9371 17.3312 13.6782 17.3313 14.4404C17.3313 16.4971 15.6643 18.1649 13.6077 18.165H6.39282C4.33605 18.165 2.66821 16.4972 2.66821 14.4404C2.66832 13.5694 2.97386 12.7258 3.53149 12.0566L6.60278 8.37109L6.65552 8.30176C6.77186 8.13447 6.83521 7.93464 6.83521 7.72949V3.16504H6.66626C6.29914 3.16486 6.00122 2.86716 6.00122 2.5C6.00122 2.13284 6.29914 1.83514 6.66626 1.83496H13.3333L13.467 1.84863C13.7702 1.91057 13.9983 2.17857 13.9983 2.5C13.9983 2.82143 13.7702 3.08943 13.467 3.15137L13.3333 3.16504H13.1653V7.72949Z" />
  </svg>
);

BeakerIcon.displayName = "BeakerIcon";
BeakerIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * BrainIcon - Brain/AI icon
 */
export const BrainIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path d="M12.417 2.08497C13.1595 2.07718 13.928 2.30924 14.5215 2.81544C15.0187 3.23964 15.3659 3.83436 15.4756 4.56837C17.7228 5.25845 18.6116 8.06419 17.2881 9.94434C18.484 11.643 17.9138 14.1413 16.0137 15.1016C15.5614 16.6946 14.2619 17.7428 12.873 17.8955C12.1235 17.9779 11.3488 17.7969 10.7002 17.2969C10.435 17.0924 10.2019 16.8392 10 16.543C9.79813 16.8392 9.565 17.0924 9.2998 17.2969C8.65115 17.7969 7.87652 17.9779 7.12695 17.8955C5.73805 17.7428 4.43755 16.6947 3.98535 15.1016C2.08588 14.141 1.51618 11.6427 2.71191 9.94434C1.3886 8.06443 2.27688 5.25892 4.52343 4.56837C4.63309 3.8343 4.98126 3.23967 5.47851 2.81544C6.07202 2.30924 6.84047 2.07718 7.583 2.08497C8.32607 2.09281 9.09216 2.34177 9.68164 2.85938C9.79607 2.9599 9.90263 3.06931 10 3.18751C10.0974 3.06931 10.2039 2.9599 10.3184 2.85938C10.9078 2.34178 11.6739 2.09282 12.417 2.08497ZM9.33496 5.14258C9.33486 4.53819 9.11005 4.1274 8.80371 3.8584C8.48431 3.57797 8.03808 3.42002 7.56933 3.41505C7.10021 3.41009 6.65707 3.55915 6.34179 3.82813C6.0406 4.08512 5.81738 4.48266 5.81738 5.07813V5.10255C5.81929 5.43475 5.57591 5.71744 5.24707 5.76465C3.51732 6.01303 2.80432 8.25192 4.04394 9.47169L4.1289 9.57325C4.20251 9.68226 4.24212 9.8118 4.24218 9.94532C4.24218 10.1235 4.17098 10.2949 4.04394 10.4199C2.97893 11.468 3.32104 13.3372 4.65917 13.9531L4.79101 14.0088L4.86914 14.044C5.04329 14.1372 5.16808 14.3043 5.20703 14.501C5.45172 15.739 6.38692 16.4768 7.27246 16.5742C7.7085 16.6221 8.13302 16.5171 8.4873 16.2441C8.83301 15.9777 9.15693 15.5133 9.33496 14.7607V5.14258ZM10.665 14.7607C10.8431 15.5133 11.167 15.9777 11.5127 16.2441C11.867 16.5171 12.2915 16.6221 12.7275 16.5742C13.6131 16.4768 14.5483 15.739 14.793 14.501L14.8144 14.419C14.8772 14.2314 15.0214 14.0801 15.209 14.0088C16.6556 13.4584 17.0552 11.5017 15.956 10.4199C15.829 10.2949 15.7578 10.1235 15.7578 9.94532C15.7579 9.76723 15.8291 9.59662 15.956 9.47169C17.1569 8.29005 16.5253 6.15225 14.9121 5.79395L14.7529 5.76465C14.4241 5.71744 14.1807 5.43475 14.1826 5.10255V5.07813L14.1719 4.86426C14.1252 4.38549 13.9218 4.05306 13.6582 3.82813C13.3429 3.55915 12.8998 3.41009 12.4307 3.41505C11.9619 3.42002 11.5157 3.57797 11.1963 3.8584C10.9282 4.09377 10.7221 4.43764 10.6748 4.92481L10.665 5.14258V14.7607Z" />
  </svg>
);

BrainIcon.displayName = "BrainIcon";
BrainIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * WebSearchIcon - Web search/globe icon
 */
export const WebSearchIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={cn("icon", className)}
    {...props}
  >
    <path d="M10 2.125C14.3492 2.125 17.875 5.65076 17.875 10C17.875 14.3492 14.3492 17.875 10 17.875C5.65076 17.875 2.125 14.3492 2.125 10C2.125 5.65076 5.65076 2.125 10 2.125ZM7.88672 10.625C7.94334 12.3161 8.22547 13.8134 8.63965 14.9053C8.87263 15.5194 9.1351 15.9733 9.39453 16.2627C9.65437 16.5524 9.86039 16.625 10 16.625C10.1396 16.625 10.3456 16.5524 10.6055 16.2627C10.8649 15.9733 11.1274 15.5194 11.3604 14.9053C11.7745 13.8134 12.0567 12.3161 12.1133 10.625H7.88672ZM3.40527 10.625C3.65313 13.2734 5.45957 15.4667 7.89844 16.2822C7.7409 15.997 7.5977 15.6834 7.4707 15.3486C6.99415 14.0923 6.69362 12.439 6.63672 10.625H3.40527ZM13.3633 10.625C13.3064 12.439 13.0059 14.0923 12.5293 15.3486C12.4022 15.6836 12.2582 15.9969 12.1006 16.2822C14.5399 15.467 16.3468 13.2737 16.5947 10.625H13.3633ZM12.1006 3.7168C12.2584 4.00235 12.4021 4.31613 12.5293 4.65137C13.0059 5.90775 13.3064 7.56102 13.3633 9.375H16.5947C16.3468 6.72615 14.54 4.53199 12.1006 3.7168ZM10 3.375C9.86039 3.375 9.65437 3.44756 9.39453 3.7373C9.1351 4.02672 8.87263 4.48057 8.63965 5.09473C8.22547 6.18664 7.94334 7.68388 7.88672 9.375H12.1133C12.0567 7.68388 11.7745 6.18664 11.3604 5.09473C11.1274 4.48057 10.8649 4.02672 10.6055 3.7373C10.3456 3.44756 10.1396 3.375 10 3.375ZM7.89844 3.7168C5.45942 4.53222 3.65314 6.72647 3.40527 9.375H6.63672C6.69362 7.56102 6.99415 5.90775 7.4707 4.65137C7.59781 4.31629 7.74073 4.00224 7.89844 3.7168Z" />
  </svg>
);

WebSearchIcon.displayName = "WebSearchIcon";
WebSearchIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * PopcornIcon - Popcorn/entertainment icon
 */
export const PopcornIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 21 20"
    fill="none"
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1244 1.83496C11.33 1.83496 12.3867 2.44818 13.0326 3.37305C13.155 3.35843 13.2797 3.35062 13.4057 3.35059C15.2061 3.35059 16.6234 4.85952 16.6234 6.66699C16.6234 6.7224 16.6148 6.77568 16.6019 6.82715C17.0368 7.13618 17.3104 7.67042 17.2172 8.27637L16.1088 15.4814C15.8711 17.0253 14.5419 18.165 12.9799 18.165H7.26992C5.70793 18.165 4.37964 17.0252 4.14199 15.4814L3.03261 8.27637C2.9394 7.67053 3.21306 7.13619 3.64784 6.82715C3.63508 6.77573 3.62639 6.72234 3.62636 6.66699C3.62636 4.85976 5.04303 3.35099 6.84316 3.35059C6.96901 3.35059 7.09384 3.35944 7.2162 3.37402C7.86195 2.4487 8.91862 1.83521 10.1244 1.83496ZM4.58241 7.89453C4.46086 7.84052 4.3281 7.94183 4.34804 8.07324L5.45644 15.2793C5.59427 16.1743 6.36438 16.8349 7.26992 16.835H7.76699L7.01113 8.90723C6.87268 8.88827 6.73594 8.85175 6.60585 8.79395L4.58241 7.89453ZM10.059 7.83594L8.31679 8.58203L9.10292 16.835H11.184L11.934 8.58203L10.1918 7.83594C10.1495 7.81781 10.1013 7.81782 10.059 7.83594ZM15.6674 7.89453L13.6439 8.79395C13.5141 8.85159 13.3777 8.88828 13.2396 8.90723L12.5189 16.835H12.9799C13.8855 16.835 14.6565 16.1743 14.7943 15.2793L15.9027 8.07324C15.9226 7.94187 15.7889 7.84052 15.6674 7.89453ZM10.1244 3.16504C9.27484 3.16532 8.52152 3.66224 8.1371 4.41797C7.9917 4.70357 7.66319 4.84478 7.35585 4.75391C7.19376 4.70595 7.02133 4.67969 6.84316 4.67969C5.84013 4.68009 4.98366 5.52042 4.95839 6.61719C5.01316 6.6345 5.06802 6.65453 5.12245 6.67871L7.14589 7.57812C7.18859 7.5971 7.23768 7.59741 7.28066 7.5791L9.53456 6.61328C9.91146 6.45176 10.3383 6.45176 10.7152 6.61328L12.9691 7.5791C13.0121 7.59751 13.0612 7.59701 13.1039 7.57812L15.1273 6.67871C15.1814 6.65469 15.236 6.63443 15.2904 6.61719C15.2651 5.52018 14.409 4.67969 13.4057 4.67969C13.2276 4.67976 13.0559 4.70596 12.8939 4.75391C12.5866 4.84471 12.2581 4.70355 12.1127 4.41797C11.7281 3.66212 10.9742 3.16504 10.1244 3.16504Z"
      fill={color}
    />
  </svg>
);

PopcornIcon.displayName = "PopcornIcon";
PopcornIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * ColorPaletteIcon - Color palette/design icon
 */
export const ColorPaletteIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path
      d="M5.875 10.25C6.42728 10.25 6.875 10.6977 6.875 11.25C6.875 11.8023 6.42728 12.25 5.875 12.25C5.32272 12.25 4.875 11.8023 4.875 11.25C4.875 10.6977 5.32272 10.25 5.875 10.25Z"
      fill={color}
    />
    <path
      d="M5.125 6.33301C5.67718 6.33301 6.12484 6.78086 6.125 7.33301C6.125 7.88529 5.67728 8.33301 5.125 8.33301C4.57272 8.33301 4.125 7.88529 4.125 7.33301C4.12516 6.78086 4.57282 6.33301 5.125 6.33301Z"
      fill={color}
    />
    <path
      d="M12.125 5.25C12.6773 5.25 13.125 5.69772 13.125 6.25C13.125 6.80228 12.6773 7.25 12.125 7.25C11.5727 7.25 11.125 6.80228 11.125 6.25C11.125 5.69772 11.5727 5.25 12.125 5.25Z"
      fill={color}
    />
    <path
      d="M8.375 3.75C8.92728 3.75 9.375 4.19772 9.375 4.75C9.375 5.30228 8.92728 5.75 8.375 5.75C7.82272 5.75 7.375 5.30228 7.375 4.75C7.375 4.19772 7.82272 3.75 8.375 3.75Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.125 0.834961C13.6344 0.834961 17.29 4.49059 17.29 9C17.29 10.5986 15.9941 11.8944 14.3955 11.8945H11.0977C10.7113 11.8946 10.3984 12.2084 10.3984 12.5947C10.3985 12.7475 10.4486 12.8959 10.541 13.0176L11.293 14.0068C11.5121 14.2952 11.6308 14.6476 11.6309 15.0098C11.6309 16.1998 10.6656 17.165 9.47559 17.165H9.125C4.61559 17.165 0.959961 13.5094 0.959961 9C0.959961 4.49059 4.61559 0.834961 9.125 0.834961ZM9.125 2.16504C5.35013 2.16504 2.29004 5.22513 2.29004 9C2.29004 12.7749 5.35013 15.835 9.125 15.835H9.47559C9.93108 15.835 10.3008 15.4653 10.3008 15.0098C10.3007 14.9382 10.2767 14.8685 10.2334 14.8115L9.48145 13.8223C9.21326 13.4693 9.06844 13.038 9.06836 12.5947C9.06836 11.4738 9.97676 10.5645 11.0977 10.5645H14.3955C15.2596 10.5643 15.96 9.8641 15.96 9C15.96 5.22513 12.8999 2.16504 9.125 2.16504Z"
      fill={color}
    />
  </svg>
);

ColorPaletteIcon.displayName = "ColorPaletteIcon";
ColorPaletteIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * HeartIcon - Heart icon
 */
export const HeartIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path d="M10.1249 3.80537C11.5032 2.66843 13.0904 2.33167 14.5312 2.64814C16.1229 2.99783 17.4823 4.13256 18.1318 5.72822C19.4632 8.99995 17.7523 13.747 10.4462 17.7819C10.2462 17.8923 10.0037 17.8924 9.80365 17.7819C2.49751 13.747 0.786678 8.99995 2.1181 5.72822C2.76756 4.13256 4.12702 2.99783 5.71869 2.64814C7.15952 2.33167 8.74667 2.66843 10.1249 3.80537ZM14.246 3.94697C13.1056 3.69643 11.7697 3.99623 10.5947 5.1706C10.335 5.42992 9.91485 5.42992 9.65521 5.1706C8.4802 3.99624 7.1443 3.69643 6.00385 3.94697C4.84779 4.20095 3.83812 5.03144 3.35053 6.22919C2.42264 8.50894 3.32341 12.569 10.1249 16.4343C16.9265 12.569 17.8273 8.50895 16.8994 6.22919C16.4118 5.03144 15.4021 4.20095 14.246 3.94697Z" />
  </svg>
);

HeartIcon.displayName = "HeartIcon";
HeartIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * NotebookIcon - Notebook/notes icon
 */
export const NotebookIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path d="M15.5847 6.5C15.5847 5.78896 15.5848 5.29563 15.5535 4.91211C15.5304 4.63016 15.4926 4.44065 15.4412 4.29688L15.3855 4.16699C15.2316 3.86488 14.9972 3.61186 14.7097 3.43555L14.5828 3.36524C14.4248 3.28478 14.2132 3.22795 13.8376 3.19727C13.4542 3.16595 12.9606 3.16504 12.2498 3.16504H7.74976C7.03889 3.16504 6.54533 3.16594 6.16187 3.19727C5.88056 3.22027 5.69123 3.25728 5.54761 3.30859L5.41675 3.36524C5.11471 3.5192 4.86253 3.75359 4.68628 4.04102L4.61499 4.16699C4.5345 4.32499 4.47772 4.53646 4.44702 4.91211C4.42359 5.19893 4.41936 5.54719 4.41772 6.00195H4.58374C4.95086 6.00213 5.24878 6.29983 5.24878 6.66699C5.2486 7.034 4.95075 7.33186 4.58374 7.33203H4.41479V9.33496H4.58374L4.71753 9.34863C5.0205 9.41069 5.24878 9.67868 5.24878 10C5.24878 10.3213 5.0205 10.5893 4.71753 10.6514L4.58374 10.665H4.41479V12.668H4.58374C4.95075 12.6681 5.2486 12.966 5.24878 13.333C5.24878 13.7002 4.95086 13.9979 4.58374 13.998H4.41772C4.41936 14.4528 4.42359 14.8011 4.44702 15.0879C4.47772 15.4635 4.5345 15.675 4.61499 15.833L4.68628 15.959C4.86253 16.2464 5.11471 16.4808 5.41675 16.6348L5.54761 16.6914C5.69123 16.7427 5.88056 16.7797 6.16187 16.8027C6.54533 16.8341 7.03889 16.835 7.74976 16.835H12.2498C12.9606 16.835 13.4542 16.8341 13.8376 16.8027C14.2132 16.772 14.4248 16.7152 14.5828 16.6348L14.7097 16.5645C14.9972 16.3881 15.2316 16.1351 15.3855 15.833L15.4412 15.7031C15.4926 15.5594 15.5304 15.3698 15.5535 15.0879C15.5848 14.7044 15.5847 14.211 15.5847 13.5V6.5ZM10.4998 9.08496C10.867 9.08496 11.1648 9.38274 11.1648 9.75C11.1648 10.1173 10.867 10.415 10.4998 10.415H7.99976C7.6326 10.4149 7.33472 10.1172 7.33472 9.75C7.33472 9.38282 7.63261 9.0851 7.99976 9.08496H10.4998ZM11.9998 6.00195L12.1335 6.01563C12.4368 6.07749 12.6648 6.3455 12.6648 6.66699C12.6646 6.98839 12.4367 7.25657 12.1335 7.31836L11.9998 7.33203H7.99976C7.63271 7.3319 7.33489 7.03403 7.33472 6.66699C7.33472 6.29981 7.6326 6.00209 7.99976 6.00195H11.9998ZM16.9148 13.5C16.9148 14.1891 16.9154 14.746 16.8787 15.1963C16.8459 15.597 16.7807 15.9576 16.6365 16.2939L16.5701 16.4365C16.3045 16.9576 15.9008 17.3941 15.405 17.6982L15.1873 17.8203C14.8105 18.0123 14.404 18.0915 13.946 18.1289C13.4958 18.1657 12.9387 18.165 12.2498 18.165H7.74976C7.06081 18.165 6.50364 18.1657 6.05347 18.1289C5.65284 18.0961 5.29209 18.031 4.95581 17.8867L4.81323 17.8203C4.2923 17.5549 3.85658 17.1509 3.55249 16.6553L3.43042 16.4365C3.23852 16.0598 3.15925 15.6542 3.12183 15.1963C3.09435 14.86 3.08926 14.464 3.08765 13.998H2.91675C2.54948 13.998 2.25171 13.7003 2.25171 13.333C2.25188 12.9659 2.54959 12.668 2.91675 12.668H3.08472V10.665H2.91675C2.54948 10.665 2.25171 10.3673 2.25171 10C2.25171 9.63273 2.54948 9.33496 2.91675 9.33496H3.08472V7.33203H2.91675C2.54959 7.33203 2.25188 7.03411 2.25171 6.66699C2.25171 6.29972 2.54948 6.00195 2.91675 6.00195H3.08765C3.08926 5.53598 3.09435 5.14004 3.12183 4.80371C3.15925 4.34583 3.23852 3.94015 3.43042 3.56348L3.55249 3.34473C3.85658 2.84915 4.2923 2.44512 4.81323 2.17969L4.95581 2.11328C5.29209 1.969 5.65284 1.90385 6.05347 1.87109C6.50364 1.83431 7.06081 1.83496 7.74976 1.83496H12.2498C12.9387 1.83496 13.4958 1.83432 13.946 1.87109C14.404 1.90851 14.8105 1.98772 15.1873 2.17969L15.405 2.30176C15.9008 2.60586 16.3045 3.04236 16.5701 3.56348L16.6365 3.70606C16.7807 4.04237 16.8459 4.40303 16.8787 4.80371C16.9154 5.25395 16.9148 5.81091 16.9148 6.5V13.5Z" />
  </svg>
);

NotebookIcon.displayName = "NotebookIcon";
NotebookIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * PlantIcon - Plant/nature icon
 */
export const PlantIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path d="M16.0013 8.33301C16.0012 8.24019 15.9262 8.16504 15.8334 8.16504H4.16638C4.07367 8.16521 3.99859 8.2403 3.99841 8.33301V10C3.99841 10.0929 4.07356 10.1678 4.16638 10.168H15.8334C15.9263 10.168 16.0013 10.093 16.0013 10V8.33301ZM5.45837 14.1143L5.60388 14.874C5.64737 15.0889 5.68795 15.2692 5.72986 15.4268C5.81152 15.7337 5.88847 15.9076 5.97791 16.0381L6.05408 16.1406C6.2387 16.3733 6.47749 16.5582 6.75037 16.6787L6.86853 16.7227C6.99631 16.763 7.15951 16.7928 7.39685 16.8105C7.72192 16.8349 8.13624 16.835 8.73669 16.835H11.267C11.8666 16.835 12.2801 16.8348 12.6049 16.8105C12.9211 16.7869 13.1057 16.7425 13.2504 16.6787L13.3656 16.623C13.6284 16.4845 13.8551 16.2841 14.0238 16.0381L14.0883 15.9307C14.1516 15.8125 14.2106 15.6576 14.2719 15.4277C14.3556 15.1132 14.4327 14.7065 14.5433 14.1172L15.0326 11.498H4.96814L5.45837 14.1143ZM14.3353 3.99805H13.3334C11.8597 3.99805 10.6654 5.19331 10.6654 6.66699V6.83496H11.6664C13.14 6.83496 14.3352 5.64052 14.3353 4.16699V3.99805ZM5.66541 4.16699C5.66558 5.64052 6.8598 6.83496 8.33337 6.83496H9.33533V5.83301L9.32166 5.56055C9.18504 4.21499 8.04798 3.16504 6.66638 3.16504H5.66541V4.16699ZM15.6654 4.16699C15.6653 5.19237 15.2786 6.1273 14.6439 6.83496H15.8334C16.6608 6.83496 17.3312 7.50565 17.3314 8.33301V10C17.3314 10.6243 16.9495 11.1586 16.4066 11.3838L15.85 14.3633C15.7429 14.9332 15.6566 15.3968 15.557 15.7705C15.468 16.1046 15.36 16.402 15.1947 16.6748L15.1205 16.79C14.8294 17.2144 14.4391 17.5608 13.9857 17.7998L13.7875 17.8955C13.4501 18.0443 13.0987 18.1072 12.7045 18.1367C12.3187 18.1656 11.8471 18.165 11.267 18.165H8.73669C8.15589 18.165 7.6834 18.1656 7.29724 18.1367C6.95221 18.1109 6.63994 18.0594 6.34119 17.9473L6.21326 17.8955C5.7424 17.6876 5.33059 17.3683 5.01208 16.9668L4.88123 16.79C4.67258 16.4857 4.54642 16.1509 4.4447 15.7686C4.39492 15.5814 4.34861 15.3718 4.30115 15.1377L4.15173 14.3594L3.59314 11.3838C3.05039 11.1586 2.66833 10.6242 2.66833 10V8.33301C2.66851 7.50576 3.33913 6.83514 4.16638 6.83496H5.35583C4.72126 6.12731 4.33541 5.19229 4.33533 4.16699V2.5L4.349 2.36621C4.41096 2.06311 4.67896 1.83496 5.00037 1.83496H6.66638C8.25269 1.83496 9.62373 2.7587 10.2699 4.09766C11.0033 3.22396 12.1034 2.66797 13.3334 2.66797H15.0004L15.1342 2.68164C15.4371 2.74365 15.6653 3.01181 15.6654 3.33301V4.16699Z" />
  </svg>
);

PlantIcon.displayName = "PlantIcon";
PlantIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * SnowflakeIcon - Snowflake/winter icon
 */
export const SnowflakeIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 21"
    fill="none"
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path
      d="M11.4184 4.29199C11.4184 3.73861 10.97 3.29029 10.4174 3.29004H9.58341C9.03064 3.29014 8.58243 3.73851 8.58243 4.29199V6.5166C8.58243 6.75415 8.45513 6.97397 8.24943 7.09277C8.04394 7.21124 7.7909 7.21117 7.58536 7.09277L5.65763 5.98047H5.65665C5.17741 5.70402 4.5659 5.86813 4.28946 6.34668H4.28849L3.87247 7.06738C3.59599 7.54627 3.75979 8.15977 4.23868 8.43652L6.16446 9.54785C6.3702 9.66658 6.49738 9.88648 6.49747 10.124C6.49747 10.3614 6.37099 10.5813 6.16544 10.7002L4.23966 11.8135H4.23868C3.76029 12.09 3.59588 12.7019 3.8715 13.1807L4.28849 13.9023L4.28946 13.9033C4.5662 14.382 5.17792 14.5456 5.65665 14.2695L7.58439 13.1562C7.79003 13.0375 8.04371 13.0377 8.24943 13.1562C8.4552 13.275 8.58243 13.4948 8.58243 13.7324V15.958C8.58243 16.5115 9.03064 16.9599 9.58341 16.96H10.4174C10.97 16.9597 11.4184 16.5114 11.4184 15.958V13.7324C11.4184 13.4949 11.5447 13.2751 11.7504 13.1562C11.9562 13.0375 12.2107 13.0374 12.4164 13.1562L14.3432 14.2695C14.822 14.5457 15.4346 14.3821 15.7113 13.9033L16.1274 13.1816L16.1742 13.0898C16.3821 12.6269 16.2093 12.0728 15.7602 11.8135L13.8334 10.7012C13.6278 10.5824 13.5014 10.3625 13.5014 10.125C13.5014 9.88738 13.6286 9.66758 13.8344 9.54883L15.7611 8.43652C16.2098 8.17737 16.3825 7.62259 16.1742 7.15918L16.1274 7.06738L15.7113 6.3457C15.4348 5.86748 14.8215 5.70373 14.3422 5.98047L12.4154 7.09277C12.2097 7.21136 11.956 7.2115 11.7504 7.09277C11.5447 6.97396 11.4184 6.75412 11.4184 6.5166V4.29199ZM12.7484 5.36426L13.6772 4.82812C14.7222 4.22477 16.0422 4.52186 16.7338 5.48047L16.8637 5.68066V5.68164L17.2797 6.40332C17.9229 7.51796 17.5413 8.94478 16.4262 9.58887L15.4965 10.125L16.4252 10.6611C17.5401 11.3048 17.923 12.7305 17.2797 13.8457L16.8637 14.5674C16.2199 15.6825 14.7925 16.0658 13.6772 15.4219L12.7484 14.8848V15.958C12.7484 17.2453 11.7053 18.2898 10.4174 18.29H9.58341C8.29553 18.2898 7.25236 17.2453 7.25236 15.958V14.8838L6.32169 15.4219C5.20644 16.0653 3.78081 15.6823 3.13712 14.5674V14.5684L2.72013 13.8467V13.8457C2.07705 12.7307 2.45886 11.3049 3.57364 10.6611L4.50138 10.124L3.57364 9.58887C2.45863 8.945 2.07624 7.51759 2.72013 6.40234L3.13712 5.68066C3.78123 4.56587 5.20704 4.18497 6.32169 4.82812L7.25236 5.36426V4.29199C7.25236 3.00474 8.29553 1.96021 9.58341 1.95996H10.4174C11.7053 1.96022 12.7484 3.00474 12.7484 4.29199V5.36426Z"
      fill={color}
    />
  </svg>
);

SnowflakeIcon.displayName = "SnowflakeIcon";
SnowflakeIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * StethoscopeIcon - Stethoscope/health icon
 */
export const StethoscopeIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 21 20"
    fill="none"
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path
      d="M4.87634 9.16653C4.87621 8.61354 4.42834 8.16573 3.87537 8.16555C3.32224 8.16555 2.87354 8.61343 2.87341 9.16653C2.87341 9.71973 3.32216 10.1685 3.87537 10.1685C4.42842 10.1683 4.87634 9.71962 4.87634 9.16653ZM6.20642 9.16653C6.20642 10.1061 5.64974 10.9136 4.849 11.2827L5.35876 14.8521C5.53712 16.1006 6.71755 16.9517 7.95837 16.7261C8.73579 16.5847 9.37958 16.0409 9.64978 15.2984L10.6381 12.5786C8.53543 11.4698 7.52099 8.95217 8.35681 6.65578L9.49646 3.52395C9.93689 2.31386 11.2756 1.68898 12.4857 2.12942L13.2679 2.41457C13.6131 2.54019 13.791 2.92199 13.6654 3.26711C13.5398 3.61214 13.1589 3.79 12.8138 3.66457L12.0306 3.37942C11.5109 3.19024 10.9358 3.45836 10.7465 3.97805L9.60681 7.11086C8.94542 8.92813 9.88232 10.9377 11.6996 11.5991C13.5167 12.2603 15.5264 11.3234 16.1879 9.50637L17.3275 6.37356C17.5167 5.85373 17.2487 5.27858 16.7289 5.08938L15.9457 4.8052C15.6006 4.67961 15.4228 4.29772 15.5482 3.95266C15.6738 3.60754 16.0556 3.42958 16.4008 3.5552L17.184 3.84035C18.3939 4.2809 19.0179 5.61865 18.5775 6.82864L17.4369 9.96047C16.6017 12.255 14.2098 13.5316 11.8881 13.0327L10.8998 15.7525C10.4681 16.9396 9.43848 17.8087 8.19568 18.0347C6.21283 18.395 4.32737 17.0357 4.04236 15.0405L3.53162 11.4702C2.40692 11.304 1.54333 10.3374 1.54333 9.16653C1.54346 7.87889 2.5877 6.83547 3.87537 6.83547C5.16288 6.83565 6.20629 7.879 6.20642 9.16653Z"
      fill={color}
    />
  </svg>
);

StethoscopeIcon.displayName = "StethoscopeIcon";
StethoscopeIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * LotusIcon - Lotus/spirituality icon
 */
export const LotusIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 21 20"
    fill="none"
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1248 2.83496C10.3101 2.835 10.4872 2.91279 10.6131 3.04883C11.226 3.71151 11.7523 4.38513 12.1892 5.06836C12.9047 4.52756 13.73 4.05501 14.6599 3.65039L14.7879 3.60938C14.9183 3.58185 15.0554 3.59363 15.1804 3.64551C15.347 3.71474 15.4788 3.84868 15.5447 4.0166C15.9839 5.13667 16.2847 6.21216 16.448 7.23633C16.9851 7.17539 17.5501 7.15545 18.1414 7.17676C18.492 7.1894 18.7723 7.47261 18.782 7.82324C18.8637 10.8284 18.2675 13.1982 16.7888 14.8135C15.302 16.4374 13.0478 17.165 10.1248 17.165C7.20173 17.165 4.94752 16.4375 3.46071 14.8135C1.98209 13.1982 1.38582 10.8284 1.46755 7.82324C1.4773 7.47267 1.75768 7.1895 2.10818 7.17676C2.6991 7.15546 3.26372 7.17548 3.80056 7.23633C3.96385 6.21217 4.26565 5.13666 4.70485 4.0166L4.76638 3.89746C4.83887 3.78584 4.94434 3.69743 5.06911 3.64551C5.23592 3.57629 5.42402 3.57834 5.58962 3.65039C6.51929 4.05488 7.34403 4.52776 8.05935 5.06836C8.49609 4.38487 9.02342 3.71168 9.6365 3.04883C9.76229 2.91287 9.93956 2.83505 10.1248 2.83496ZM10.1248 4.50586C9.59648 5.1367 9.1631 5.76655 8.82107 6.39258C8.55024 6.8883 8.33645 7.3819 8.17849 7.87305C8.13905 7.99555 8.10362 8.11805 8.07107 8.24023C7.9733 8.60767 7.90637 8.97357 7.86989 9.33789C7.76051 10.4306 8.06157 11.712 8.65603 13C8.97231 13.6853 9.78 15.3081 10.0418 15.833C10.0693 15.8331 10.097 15.835 10.1248 15.835C10.1522 15.835 10.1796 15.8331 10.2068 15.833C10.4682 15.3086 11.277 13.6855 11.5935 13C12.1883 11.712 12.49 10.4306 12.3806 9.33789C12.3442 8.9736 12.2772 8.60765 12.1795 8.24023C12.1469 8.11796 12.1105 7.99564 12.0711 7.87305C12.0029 7.66103 11.9228 7.44924 11.8338 7.23633C11.7165 6.95595 11.5824 6.6743 11.4285 6.39258C11.4273 6.39038 11.4258 6.38795 11.4246 6.38574C11.0831 5.76202 10.6511 5.13434 10.1248 4.50586ZM2.79079 8.50293C2.81214 11.0024 3.38395 12.7611 4.44118 13.916C5.37183 14.9325 6.76097 15.5683 8.72634 15.7666C7.37907 13.8353 6.45289 11.5867 6.52224 9.58203C5.8978 9.13427 5.14223 8.81884 4.24587 8.64746C3.79693 8.56164 3.31207 8.51388 2.79079 8.50293ZM17.4578 8.50293C16.9369 8.51393 16.4523 8.5617 16.0037 8.64746C15.1073 8.81887 14.3517 9.13423 13.7273 9.58203C13.7967 11.5869 12.8698 13.8351 11.5222 15.7666C13.4882 15.5684 14.8775 14.9326 15.8084 13.916C16.8656 12.7611 17.4364 11.0024 17.4578 8.50293ZM5.69802 5.16992C5.41652 5.98368 5.22072 6.75563 5.1072 7.48438C5.69025 7.64246 6.2305 7.86132 6.72634 8.1416C6.73045 8.1241 6.73578 8.10636 6.74001 8.08887C6.77188 7.95707 6.80709 7.82566 6.84548 7.69434C6.85325 7.66766 6.86088 7.64092 6.86892 7.61426C6.90743 7.48699 6.94931 7.36018 6.99392 7.2334C7.00299 7.20749 7.01095 7.18116 7.02028 7.15527C7.06186 7.04038 7.10654 6.926 7.1531 6.81152C7.1722 6.76441 7.19077 6.71696 7.21071 6.66992C7.25504 6.56565 7.3029 6.46229 7.35134 6.3584C7.36908 6.32032 7.3848 6.28119 7.4031 6.24316C6.91004 5.85328 6.34295 5.49416 5.69802 5.16992ZM14.5506 5.16992C13.9058 5.49413 13.3384 5.85237 12.8455 6.24219C13.147 6.86843 13.372 7.50195 13.5222 8.14062C14.0179 7.86035 14.5585 7.64251 15.1414 7.48438C15.0278 6.75555 14.8321 5.98378 14.5506 5.16992Z"
      fill={color}
    />
  </svg>
);

LotusIcon.displayName = "LotusIcon";
LotusIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * SuitcaseIcon - Suitcase/travel icon
 */
export const SuitcaseIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path d="M16.6263 9.833C16.6263 9.12214 16.6264 8.62857 16.5951 8.24511C16.5721 7.96372 16.5341 7.7745 16.4828 7.63086L16.4271 7.5C16.2732 7.198 16.0386 6.94582 15.7513 6.76953L15.6244 6.69824C15.4664 6.61782 15.2548 6.56095 14.8793 6.53027C14.4958 6.49896 14.0023 6.49804 13.2914 6.49804H6.70837C5.99734 6.49804 5.504 6.49894 5.12048 6.53027C4.83848 6.55331 4.64903 6.5911 4.50525 6.64258L4.37537 6.69824C4.07317 6.85221 3.82024 7.08648 3.64392 7.37402L3.57361 7.5C3.49312 7.65796 3.43635 7.86961 3.40564 8.24511C3.37431 8.62857 3.37341 9.12214 3.37341 9.833V12.667C3.37341 13.3779 3.37431 13.8714 3.40564 14.2549C3.43635 14.6304 3.49312 14.842 3.57361 15L3.64392 15.126C3.82024 15.4135 4.07317 15.6478 4.37537 15.8018L4.50525 15.8574C4.64903 15.9089 4.83848 15.9467 5.12048 15.9697C5.504 16.0011 5.99734 16.002 6.70837 16.002H13.2914C14.0023 16.002 14.4958 16.001 14.8793 15.9697C15.2548 15.939 15.4664 15.8822 15.6244 15.8018L15.7513 15.7305C16.0386 15.5542 16.2732 15.302 16.4271 15L16.4828 14.8691C16.5341 14.7255 16.5721 14.5363 16.5951 14.2549C16.6264 13.8714 16.6263 13.3779 16.6263 12.667V9.833ZM10.0004 3.16504C9.38692 3.16504 9.07658 3.16777 8.87048 3.19336L8.69177 3.22754C8.09807 3.38662 7.6265 3.83141 7.43005 4.4082L7.39392 4.52539C7.35649 4.6653 7.34232 4.8343 7.3363 5.16797H12.6635C12.6597 4.9606 12.654 4.81679 12.64 4.7041L12.6058 4.52539C12.4467 3.93162 12.0021 3.4591 11.4252 3.26269L11.308 3.22754C11.096 3.1708 10.8175 3.16504 10.0004 3.16504ZM17.9564 12.667C17.9564 13.3559 17.9571 13.9131 17.9203 14.3633C17.8875 14.7639 17.8224 15.1246 17.6781 15.4609L17.6117 15.6035C17.3462 16.1245 16.9423 16.5602 16.4467 16.8643L16.2289 16.9863C15.8521 17.1783 15.4457 17.2575 14.9877 17.2949C14.5375 17.3317 13.9804 17.332 13.2914 17.332H6.70837C6.01928 17.332 5.46233 17.3317 5.01209 17.2949C4.61151 17.2622 4.25067 17.1979 3.91443 17.0537L3.77185 16.9863C3.25065 16.7208 2.81424 16.3172 2.51013 15.8213L2.38806 15.6035C2.19621 15.2269 2.1169 14.821 2.07947 14.3633C2.04269 13.9131 2.04334 13.3559 2.04334 12.667V9.833C2.04334 9.14406 2.04269 8.58689 2.07947 8.13672C2.1169 7.67895 2.19621 7.27308 2.38806 6.89648L2.51013 6.67871C2.81424 6.18278 3.25065 5.77923 3.77185 5.51367L3.91443 5.44629C4.25067 5.30209 4.61151 5.23781 5.01209 5.20508C5.29794 5.18172 5.6269 5.17386 6.00525 5.1709C6.01203 4.77676 6.03422 4.46253 6.10974 4.18066L6.17127 3.97851C6.51023 2.98399 7.32423 2.2167 8.34802 1.94238L8.51013 1.90527C8.8991 1.83029 9.35972 1.83496 10.0004 1.83496C10.7324 1.83496 11.229 1.82884 11.6527 1.94238L11.8549 2.0039C12.8495 2.34282 13.6166 3.15683 13.891 4.18066L13.9281 4.34375C13.9743 4.58375 13.988 4.85098 13.9935 5.1709C14.3724 5.17385 14.7015 5.1817 14.9877 5.20508C15.4457 5.2425 15.8521 5.3217 16.2289 5.51367L16.4467 5.63574C16.9423 5.93983 17.3462 6.37546 17.6117 6.89648L17.6781 7.03906C17.8224 7.37537 17.8875 7.73605 17.9203 8.13672C17.9571 8.58689 17.9564 9.14406 17.9564 9.833V12.667Z" />
  </svg>
);

SuitcaseIcon.displayName = "SuitcaseIcon";
SuitcaseIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * PlaneIcon - Plane/travel icon
 */
export const PlaneIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path d="M16.71 3.41504H15.9366C15.229 3.41504 14.5502 3.69606 14.0499 4.19629L11.8038 6.44238C11.6228 6.62338 11.3538 6.68466 11.1124 6.59961L5.25494 4.53223C4.89132 4.40404 4.48659 4.49596 4.21392 4.76855L3.87994 5.10156L8.51666 8.66699C8.66833 8.78367 8.76207 8.96041 8.77447 9.15137C8.78687 9.34233 8.71642 9.52973 8.58111 9.66504L6.97076 11.2754C6.84605 11.4001 6.67642 11.4707 6.50005 11.4707H5.16412L4.07525 12.5596L5.62115 13.1387C6.25169 13.3751 6.74993 13.8734 6.98638 14.5039L7.56451 16.0488L8.65435 14.96V13.625C8.65435 13.4486 8.72495 13.279 8.84966 13.1543L10.46 11.5439L10.5137 11.4961C10.6428 11.3922 10.8066 11.3397 10.9737 11.3506C11.1646 11.363 11.3414 11.4567 11.4581 11.6084L15.0225 16.2441L15.3565 15.9111C15.6291 15.6385 15.721 15.2337 15.5928 14.8701L13.5254 9.0127C13.4404 8.7713 13.5017 8.50228 13.6827 8.32129L15.9288 6.0752C16.429 5.57481 16.71 4.89603 16.71 4.18848V3.41504ZM18.0401 4.18848C18.0401 5.24876 17.6188 6.26582 16.8692 7.01562L14.919 8.96484L16.8467 14.4268C17.1456 15.2734 16.9318 16.2166 16.2969 16.8516L15.4288 17.7207C15.2935 17.8559 15.106 17.9265 14.9151 17.9141C14.7242 17.9016 14.5483 17.8069 14.4317 17.6553L10.8653 13.0195L9.98443 13.9004V15.2363C9.98437 15.4125 9.91455 15.5814 9.79009 15.7061L7.77544 17.7207C7.61567 17.8802 7.38576 17.9481 7.16509 17.9004C6.94412 17.8525 6.76206 17.6951 6.68267 17.4834L5.74029 14.9707C5.63871 14.6999 5.4252 14.4863 5.15435 14.3848L2.64166 13.4424C2.42995 13.363 2.27253 13.1809 2.22466 12.96C2.17699 12.7393 2.24487 12.5094 2.40435 12.3496L4.419 10.335L4.51959 10.252C4.62801 10.1796 4.75647 10.1407 4.88873 10.1406H6.22369L7.10455 9.25879L2.46978 5.69336C2.31819 5.57672 2.22344 5.40082 2.21099 5.20996C2.1986 5.01908 2.26914 4.83159 2.40435 4.69629L3.27349 3.82812C3.90842 3.19328 4.85161 2.97949 5.6983 3.27832L11.1592 5.20508L13.1094 3.25586C13.8592 2.50621 14.8763 2.08496 15.9366 2.08496H17.3751C17.7423 2.08496 18.0401 2.38273 18.0401 2.75V4.18848Z" />
  </svg>
);

PlaneIcon.displayName = "PlaneIcon";
PlaneIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * GlobeIcon - Globe/web search icon
 */
export const GlobeIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path d="M2.79333 7.5C2.79333 5.4093 3.58001 3.50072 4.87244 2.05664C5.11737 1.78298 5.53822 1.75995 5.81189 2.00488C6.08519 2.24984 6.10839 2.66981 5.86365 2.94336C4.78095 4.15304 4.12341 5.74901 4.12341 7.5C4.12341 11.2749 7.18351 14.335 10.9584 14.335C12.9826 14.335 14.8006 13.456 16.0531 12.0566C16.298 11.783 16.7189 11.7599 16.9926 12.0049C17.2658 12.2498 17.289 12.6698 17.0443 12.9434C15.6886 14.4581 13.7731 15.4613 11.6234 15.6348V16.835H13.8754C14.2424 16.8352 14.5404 17.1329 14.5404 17.5C14.5404 17.8671 14.2424 18.1648 13.8754 18.165H8.04138C7.67423 18.1649 7.37635 17.8672 7.37634 17.5C7.37634 17.1328 7.67422 16.8351 8.04138 16.835H10.2933V15.6357C6.09507 15.2972 2.79333 11.7854 2.79333 7.5ZM15.2933 7.5C15.2933 5.10585 13.3525 3.16504 10.9584 3.16504C8.56422 3.16504 6.62341 5.10585 6.62341 7.5C6.62341 9.89415 8.56422 11.835 10.9584 11.835C13.3525 11.835 15.2933 9.89415 15.2933 7.5ZM16.6234 7.5C16.6234 10.6287 14.0871 13.165 10.9584 13.165C7.82968 13.165 5.29333 10.6287 5.29333 7.5C5.29333 4.37131 7.82968 1.83496 10.9584 1.83496C14.0871 1.83496 16.6234 4.37131 16.6234 7.5Z" />
  </svg>
);

GlobeIcon.displayName = "GlobeIcon";
GlobeIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * PawIcon - Paw/pets icon
 */
export const PawIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path d="M10.125 8.33506C10.8997 8.33506 11.7321 8.74496 12.4522 9.27549C13.1937 9.82182 13.9136 10.5677 14.4727 11.3878C15.0279 12.2021 15.456 13.1374 15.5498 14.0636C15.6463 15.0165 15.3848 15.9708 14.5557 16.6925C13.9514 17.2183 13.3041 17.3495 12.6748 17.169C12.1212 17.0102 11.6451 16.6253 11.2813 16.3087L11.2686 16.296C11.0241 16.0716 10.6032 15.9229 10.1377 15.9229C9.66625 15.923 9.29854 16.0743 9.11917 16.2638L9.09671 16.2872L9.0723 16.3087C8.69152 16.64 8.19352 17.0168 7.61722 17.172C6.98204 17.3429 6.31002 17.2282 5.69437 16.6925C4.86529 15.9708 4.60375 15.0165 4.70023 14.0636C4.7941 13.1374 5.22221 12.2021 5.77738 11.3878C6.33651 10.5677 7.05635 9.82182 7.79788 9.27549C8.518 8.74496 9.35041 8.33506 10.125 8.33506ZM10.125 9.66514C9.77443 9.66514 9.22565 9.87621 8.58695 10.3468C7.96972 10.8015 7.35319 11.437 6.87601 12.1368C6.39482 12.8426 6.08738 13.5669 6.02347 14.1974C5.96233 14.8007 6.12026 15.3003 6.56741 15.6896C6.84676 15.9326 7.06123 15.9444 7.27152 15.8878C7.53957 15.8156 7.84451 15.6116 8.19534 15.3067C8.70779 14.7965 9.45941 14.5929 10.1377 14.5929C10.8353 14.5929 11.6031 14.8065 12.1543 15.3048C12.5235 15.626 12.8014 15.8219 13.041 15.8907C13.205 15.9377 13.3921 15.9424 13.6826 15.6896C14.1298 15.3003 14.2877 14.8007 14.2266 14.1974C14.1627 13.5669 13.8552 12.8426 13.3741 12.1368C12.8969 11.437 12.2803 10.8015 11.6631 10.3468C11.0244 9.87621 10.4756 9.66514 10.125 9.66514ZM3.29788 6.10166C3.86506 5.9774 4.41786 6.16123 4.8428 6.46885C5.27117 6.779 5.6175 7.24496 5.80081 7.79307L5.86038 7.99912C5.98063 8.48231 5.96068 8.9751 5.79007 9.40342C5.59162 9.90125 5.18284 10.3135 4.59964 10.4415C4.03237 10.566 3.47976 10.3829 3.05472 10.0753C2.62634 9.76519 2.28007 9.29914 2.09671 8.75108C1.91358 8.20364 1.91231 7.62928 2.10745 7.13975C2.30597 6.64204 2.71477 6.22959 3.29788 6.10166ZM15.4073 6.46885C15.8322 6.16123 16.385 5.9774 16.9522 6.10166C17.5353 6.22959 17.9441 6.64204 18.1426 7.13975C18.3378 7.62928 18.3365 8.20364 18.1534 8.75108C17.97 9.29914 17.6237 9.7652 17.1953 10.0753C16.7703 10.3829 16.2177 10.566 15.6504 10.4415C15.0672 10.3135 14.6584 9.90125 14.46 9.40342C14.2651 8.91401 14.2662 8.3403 14.4493 7.79307L14.5254 7.5919C14.7204 7.13112 15.0323 6.7403 15.4073 6.46885ZM3.58206 7.40147C3.49082 7.42163 3.40227 7.48374 3.34281 7.63291C3.28001 7.79067 3.25974 8.03711 3.35745 8.3292C3.45495 8.62065 3.63634 8.85501 3.83402 8.99815C4.03506 9.14368 4.20717 9.16617 4.31448 9.14268C4.40588 9.12263 4.49418 9.0606 4.55374 8.91123C4.60877 8.77319 4.63116 8.5675 4.57034 8.32236L4.53909 8.21494C4.44158 7.92344 4.26025 7.68913 4.06253 7.546C3.86149 7.40052 3.68934 7.37793 3.58206 7.40147ZM16.668 7.40147C16.5607 7.37793 16.3886 7.40052 16.1875 7.546C16.0145 7.67127 15.8538 7.86635 15.751 8.1085L15.711 8.21494C15.6132 8.50721 15.6334 8.75349 15.6963 8.91123C15.7559 9.0606 15.8442 9.12263 15.9356 9.14268C16.0429 9.16617 16.215 9.14368 16.416 8.99815C16.6137 8.85501 16.7951 8.62065 16.8926 8.3292C16.9903 8.03711 16.9701 7.79067 16.9073 7.63291C16.8478 7.48374 16.7592 7.42163 16.668 7.40147ZM7.63968 2.75498C8.25292 2.77677 8.76019 3.12459 9.09964 3.5626C9.4418 4.00417 9.65477 4.58312 9.68363 5.19932C9.71243 5.81475 9.55447 6.40438 9.2305 6.85361C8.90272 7.30805 8.38552 7.63457 7.75784 7.6124C7.14463 7.59063 6.63636 7.24373 6.29691 6.80576C5.95465 6.36413 5.74179 5.78438 5.71292 5.16807C5.68413 4.55263 5.84305 3.963 6.16702 3.51377C6.49487 3.05939 7.01197 2.73269 7.63968 2.75498ZM12.6104 2.75498C13.2381 2.73269 13.7552 3.05939 14.083 3.51377C14.407 3.96301 14.5659 4.55263 14.5371 5.16807C14.5083 5.78438 14.2954 6.36413 13.9532 6.80576C13.6137 7.24373 13.1054 7.59063 12.4922 7.6124C11.8645 7.63456 11.3473 7.30805 11.0196 6.85361C10.6956 6.40438 10.5376 5.81476 10.5664 5.19932C10.5953 4.58312 10.8083 4.00418 11.1504 3.5626C11.4899 3.12458 11.9971 2.77677 12.6104 2.75498ZM7.5928 4.08408C7.49117 4.08047 7.36552 4.12518 7.24515 4.29209C7.12099 4.46433 7.02528 4.74692 7.04202 5.10557C7.05877 5.46341 7.18303 5.77655 7.34866 5.99033C7.51717 6.20776 7.68846 6.27917 7.80472 6.2833C7.90633 6.28691 8.03105 6.24214 8.1514 6.07529C8.27562 5.90305 8.37227 5.6206 8.3555 5.26182C8.33878 4.90405 8.21445 4.59082 8.04886 4.37705C7.88054 4.15986 7.70906 4.08835 7.5928 4.08408ZM12.6573 4.08408C12.541 4.08835 12.3695 4.15986 12.2012 4.37705C12.0356 4.59082 11.9113 4.90405 11.8946 5.26182C11.8778 5.62061 11.9744 5.90305 12.0987 6.07529C12.219 6.24212 12.3437 6.2869 12.4453 6.2833C12.5616 6.27917 12.7329 6.20775 12.9014 5.99033C13.067 5.77656 13.1913 5.46341 13.208 5.10557C13.2248 4.74692 13.1291 4.46433 13.0049 4.29209C12.8845 4.12519 12.7589 4.08047 12.6573 4.08408Z" />
  </svg>
);

PawIcon.displayName = "PawIcon";
PawIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * DumbBellIcon - Dumbbell/fitness icon
 */
export const DumbBellIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path d="M17.7936 7.66675C17.7936 7.48184 17.6435 7.33196 17.4586 7.33179H16.9586C16.7736 7.33179 16.6237 7.48173 16.6237 7.66675V12.3337L16.6305 12.4011C16.6618 12.5536 16.7968 12.6687 16.9586 12.6687H17.4586C17.6434 12.6685 17.7934 12.5185 17.7936 12.3337V7.66675ZM2.45667 12.3337C2.45684 12.5186 2.60672 12.6687 2.79163 12.6687H3.29163C3.45345 12.6687 3.58844 12.5537 3.61975 12.4011L3.62659 12.3337V7.66675C3.62659 7.48173 3.47664 7.33179 3.29163 7.33179H2.79163C2.60661 7.33179 2.45667 7.48173 2.45667 7.66675V12.3337ZM6.95959 5.16675C6.95959 4.98173 6.80965 4.83179 6.62463 4.83179H5.29163C5.10661 4.83179 4.95667 4.98173 4.95667 5.16675V14.8337C4.95684 15.0186 5.10672 15.1687 5.29163 15.1687H6.62463C6.80954 15.1687 6.95942 15.0186 6.95959 14.8337V5.16675ZM15.2936 5.16675C15.2936 4.98184 15.1435 4.83196 14.9586 4.83179H13.6246C13.4398 4.83196 13.2897 4.98184 13.2897 5.16675V14.8337C13.2898 15.0185 13.4399 15.1685 13.6246 15.1687H14.9586C15.1434 15.1685 15.2934 15.0185 15.2936 14.8337V5.16675ZM16.6237 6.03491C16.7317 6.01287 16.844 6.00171 16.9586 6.00171H17.4586C18.378 6.00189 19.1237 6.7473 19.1237 7.66675V12.3337C19.1235 13.253 18.3779 13.9986 17.4586 13.9988H16.9586C16.844 13.9988 16.7318 13.9867 16.6237 13.9646V14.8337C16.6235 15.753 15.8779 16.4986 14.9586 16.4988H13.6246C12.7053 16.4986 11.9598 15.753 11.9596 14.8337V10.6648H8.28967V14.8337C8.2895 15.7531 7.54408 16.4988 6.62463 16.4988H5.29163C4.37218 16.4988 3.62676 15.7531 3.62659 14.8337V13.9646C3.51838 13.9867 3.40637 13.9988 3.29163 13.9988H2.79163C1.87218 13.9988 1.12676 13.2531 1.12659 12.3337V7.66675C1.12659 6.74719 1.87207 6.00171 2.79163 6.00171H3.29163C3.40632 6.00171 3.51842 6.01283 3.62659 6.03491V5.16675C3.62659 4.2472 4.37207 3.50171 5.29163 3.50171H6.62463C7.54419 3.50171 8.28967 4.24719 8.28967 5.16675V9.33472H11.9596V5.16675C11.9596 4.2473 12.7052 3.50188 13.6246 3.50171H14.9586C15.878 3.50188 16.6237 4.2473 16.6237 5.16675V6.03491Z" />
  </svg>
);

DumbBellIcon.displayName = "DumbBellIcon";
DumbBellIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * KettleBellIcon - Kettlebell/fitness icon
 */
export const KettleBellIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path d="M15.2936 12.083C15.2935 10.6667 14.6182 9.38387 13.525 8.50488C12.6197 7.77694 11.4318 7.33203 10.1246 7.33203C8.81765 7.33211 7.63048 7.7771 6.72522 8.50488C5.632 9.38387 4.95677 10.6667 4.95667 12.083C4.95667 14.6616 7.22313 16.8348 10.1246 16.835C13.0263 16.835 15.2936 14.6617 15.2936 12.083ZM14.4596 5.83301C14.4595 5.20416 14.0774 4.55316 13.2916 4.0293C12.5104 3.5085 11.3923 3.16504 10.1246 3.16504C8.85723 3.1651 7.73982 3.50862 6.95862 4.0293C6.17282 4.55316 5.7898 5.20416 5.78967 5.83301C5.78967 6.27238 5.97669 6.71833 6.35608 7.12793C7.42173 6.41704 8.72392 6.00202 10.1246 6.00195C11.5253 6.00195 12.8275 6.41717 13.8932 7.12793C14.2728 6.71825 14.4596 6.2725 14.4596 5.83301ZM15.7897 5.83301C15.7897 6.65095 15.4518 7.38133 14.9186 7.97852C15.9709 9.05461 16.6236 10.4931 16.6237 12.083C16.6237 15.4874 13.6663 18.165 10.1246 18.165C6.58312 18.1649 3.62659 15.4873 3.62659 12.083C3.62668 10.4932 4.27852 9.05457 5.33069 7.97852C4.7976 7.38139 4.45959 6.6508 4.45959 5.83301C4.45973 4.62118 5.19676 3.60527 6.22034 2.92285C7.24862 2.23733 8.63107 1.83502 10.1246 1.83496C11.6181 1.83496 13.0006 2.23743 14.0289 2.92285C15.0526 3.60527 15.7895 4.62115 15.7897 5.83301Z" />
  </svg>
);

KettleBellIcon.displayName = "KettleBellIcon";
KettleBellIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

/**
 * ScalesIcon - Scales/balance icon
 */
export const ScalesIcon = ({
  size = 20,
  className = "",
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21 21"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={cn("icon", className)}
    aria-hidden="true"
    {...props}
  >
    <path d="M9.39746 2.51562C9.39746 2.14838 9.69526 1.85062 10.0625 1.85059C10.4298 1.85059 10.7275 2.14836 10.7275 2.51562V3.85254C10.7853 3.88104 10.8419 3.91286 10.8965 3.94922L11.4678 4.33105C12.3228 4.90104 13.3279 5.20508 14.3555 5.20508H17.3301C17.6972 5.20525 17.9951 5.50295 17.9951 5.87012C17.9949 6.23713 17.6971 6.53499 17.3301 6.53516H16.708L18.5215 12.124C18.5942 12.3481 18.5429 12.5942 18.3867 12.7705C17.6534 13.5983 16.7566 14.082 15.792 14.082C14.8276 14.0819 13.9315 13.5981 13.1982 12.7705C13.042 12.5942 12.9908 12.3481 13.0635 12.124L14.877 6.53516H14.3555C13.0654 6.53516 11.8039 6.15306 10.7305 5.4375L10.7275 5.43457V16.1055H13.417C13.784 16.1056 14.0819 16.4035 14.082 16.7705C14.082 17.1377 13.7841 17.4354 13.417 17.4355H6.70801C6.34091 17.4353 6.04297 17.1376 6.04297 16.7705C6.04314 16.4035 6.34102 16.1057 6.70801 16.1055H9.39746V5.43457L9.39453 5.4375C8.32108 6.15313 7.05966 6.53515 5.76953 6.53516H5.24804L7.06152 12.124C7.13424 12.3481 7.08298 12.5942 6.92676 12.7705C6.19351 13.5981 5.29741 14.0819 4.33301 14.082C3.36843 14.082 2.47162 13.5983 1.73828 12.7705C1.58209 12.5942 1.53082 12.3481 1.60351 12.124L3.41699 6.53516H2.79492C2.42781 6.53509 2.13006 6.2372 2.12988 5.87012C2.12988 5.50289 2.42771 5.20514 2.79492 5.20508H5.76953C6.7969 5.20508 7.80137 4.90085 8.65625 4.33105L9.22851 3.94922C9.28307 3.91286 9.33972 3.88104 9.39746 3.85254V2.51562ZM2.99316 12.1504C3.45865 12.5782 3.91968 12.752 4.33301 12.752C4.74619 12.7519 5.20657 12.578 5.67187 12.1504L4.33203 8.02344L2.99316 12.1504ZM14.4521 12.1504C14.9176 12.5784 15.3787 12.7518 15.792 12.752C16.2051 12.752 16.6656 12.5778 17.1309 12.1504L15.792 8.02344L14.4521 12.1504Z" />
  </svg>
);

ScalesIcon.displayName = "ScalesIcon";
ScalesIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};
